function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext, useId, useRef } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { FiArrowRight } from 'react-icons/fi';
import { Body, CallToAction, Container, EntryAnimation, Heading, Label } from '../../atoms';
import { PatternFigure } from '../../molecules';
import ReactConfigContext from '../../ReactConfigContext';
export default function PictureAndContentSection(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? 'image-first' : _param_variant, _param_imageType = param.imageType, imageType = _param_imageType === void 0 ? 'pattern' : _param_imageType, _param_patternVariant = param.patternVariant, patternVariant = _param_patternVariant === void 0 ? '2' : _param_patternVariant, background = param.background, label = param.label, image = param.image, secondaryImage = param.secondaryImage, title = param.title, description = param.description, callToActions = param.callToActions, className = param.className;
    var id = useId();
    var containerRef = useRef(null);
    var _useContext = useContext(ReactConfigContext), ImageComponent = _useContext.config.ImageComponent;
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: PictureAndContentSection.name,
        background: background,
        className: className,
        containerClassName: twMerge(imageType === 'small-image' && 'max-w-md')
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge('grid grid-cols-1 grid-flow-row auto-rows-max items-center', imageType !== 'wide-image' && 'gap-6 md:gap-11 lg:gap-13', imageType === 'wide-image' && 'gap-6 md:gap-8 md:grid-cols-2', imageType === 'small-image' && 'gap-6 md:gap-9 lg:gap-11', imageType !== 'wide-image' && twMerge(variant === 'image-first' && 'md:grid-cols-[2fr_3fr]', variant === 'image-last' && 'md:grid-cols-[3fr_2fr]'), imageType === 'small-image' && twMerge(variant === 'image-first' && 'md:grid-cols-[1fr_2fr]', variant === 'image-last' && 'md:grid-cols-[2fr_1fr]'))
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge(variant === 'image-first' && 'order-first', variant === 'image-last' && 'order-first md:order-last')
    }, /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef
    }, imageType === 'pattern' && /*#__PURE__*/ React.createElement(PatternFigure, {
        variant: patternVariant,
        images: secondaryImage ? [
            image,
            secondaryImage
        ] : [
            image
        ]
    }), (imageType === 'image-only' || imageType === 'wide-image' || imageType === 'small-image') && /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, image), {
        className: twMerge(image.className, 'w-full h-auto rounded-xl overflow-hidden safari-fix-transform', imageType === 'small-image' && 'max-w-[50%] mx-auto md:max-w-none')
    })))), /*#__PURE__*/ React.createElement("div", null, !!label && /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef,
        delay: 0.1,
        className: "mb-4"
    }, /*#__PURE__*/ React.createElement(Label, {
        className: "text-blue-500"
    }, label)), !!title && /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef,
        delay: 0.2
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h2",
        variant: imageType === 'small-image' ? 'h3' : 'h2'
    }, title)), !!description && /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef,
        delay: 0.3,
        className: "mt-4 md:mt-6"
    }, /*#__PURE__*/ React.createElement(Body, {
        className: "prose"
    }, description)), !!(callToActions === null || callToActions === void 0 ? void 0 : callToActions.length) && /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef,
        delay: 0.4,
        className: "mt-4 md:mt-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap items-center justify-start -m-2"
    }, callToActions.map(function(action) {
        return /*#__PURE__*/ React.createElement(CallToAction, _object_spread_props(_object_spread({}, action), {
            key: "action-".concat(id, "-").concat(action.href),
            className: twMerge(action.className, 'block m-2'),
            buttonType: "icon-after",
            icon: /*#__PURE__*/ React.createElement(FiArrowRight, null)
        }));
    }))))));
}

//# sourceMappingURL=PictureAndContentSection.js.map